import React, { useState } from "react";

import "../Styles/Investors.css"; // Create this CSS if needed
import InvestorLineChart from "../components/InvestorLineChart";
import InvestorSignupForm from "../components/InvestorSignupForm";
import { useNavigate } from "react-router-dom";

const Investors = () => {
  const [showInvestorForm, setShowInvestorForm] = useState(false);
  const navigate = useNavigate();

  return (
<div className="investors-page">
<button className="back-button" onClick={() => navigate("/services")}>
  ← Back to Services
</button>
  <div className="header-container">
    <h2>📈 Investors</h2>
  </div>

  <div className="description">
    <p>
      RCS recently opened its assets to the public, allowing for investments ranging from short term to long term.
      <br/><br/>
      Investing in RCS is as easy as 1.2.3..., let your money work for you! invest in RCS today and earn dividends every 6 Weeks, 6 Months or Annually.
      <br/><br/>
      <strong>Terms and Conditions apply</strong>
    </p>
  </div>
  <div className="info-row">
  <div className="info-box">
    <h4>📊 Investment Types</h4>
    <p>
      Choose from a range of flexible investment periods:
      <ul>
        <li>6 Weeks – Quick short-term ROI</li>
        <li>6 Months – Medium-term gain</li>
        <li>1 Year – Long-term dividend plan</li>
      </ul>
      <br/><br/>
      RCS allows felixable investments, catered to suit your needs.
      <br/><br/>
      <button className="investor-signup-btn" onClick={() => setShowInvestorForm(true)}>
  📝 Become an Investor
</button>

    </p>
  </div>

  <div className="info-box">
    <h4>📈 Investment Statistics</h4>
    <p>
      February 2025, makes approximately one year, since RCS opened its doors to investors, from February 2024 to February 2025, RCS
      had a total of 25 Investors!
<br/><br/>
To date; <strong>(April 1, 2025);</strong>
RCS has a total of 34 active investors!
<br/><br/>
See below our investor stats:
<InvestorLineChart />
    </p>
  </div>
</div>
{showInvestorForm && (
  <InvestorSignupForm onClose={() => setShowInvestorForm(false)} />
)}

</div>

  );
};

export default Investors;
